import { RetentionChartItem } from '@/common/model/media/queryFanout'

// クエリ・ファンアウト分析の analysis_type 識別子
export const QUERY_FANOUT_ANALYSIS_TYPE = 'query_fanout'

// 競合は最大5社まで
export const MAX_COMPETITORS = 5

// 会話深度のラベル
const DEPTH_LABELS = [
  'メイン質問',
  'フォローアップ1',
  'フォローアップ2',
  'フォローアップ3',
  'フォローアップ4'
]

export const depthLabel = (depth: number): string => DEPTH_LABELS[depth] ?? `Depth ${depth}`

// 深度をキーにしたリテンション（競合ブランド数・自社ブランドの有無）の索引
export const retentionByDepth = (
  retentionChart: RetentionChartItem[]
): Record<number, RetentionChartItem> =>
  Object.fromEntries(retentionChart.map((item) => [item.depth, item]))
